export const kebabCase = (string) => {
    string
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .toLowerCase();
};
export const addToIndex = (array, item, index) => {
    const newArray = [...array];
    newArray.splice(index, 0, item);
    return newArray;
};
export const uniqueBy = (arr, key) => {
    const seen = new Set();
    return arr.filter((item) => {
        const k = item[key];
        return seen.has(k) ? false : seen.add(k);
    });
};
export const isInIframe = () => {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
export const inlineStyle = (styleObject) => {
    const validStyles = [];
    Object.keys(styleObject).forEach((key) => {
        const value = styleObject[key];
        if (!value)
            return;
        validStyles.push(`${key}: ${value};`);
    });
    return validStyles.join('');
};
export const randomBetween = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
};
